module.exports = __webpack_public_path__ + "img/visa-alternate.a4da2833.png";